import Vue from "vue";
import iView from "iview";
import { router } from "./router/index";
import { appRouter, menuRoutes, otherRouter, routers } from "./router/router";
import store from "./store";
import App from "./app.vue";
import "./filter/index.js";
import "./locale";
import Util from "./libs/util";
import "iview/dist/styles/iview.css";
import "font-awesome/css/font-awesome.css";
import Main from "@/views/Main.vue";
import Cookies from "js-cookie";
const xhr = require("xhr");
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "./style.css";
import moment from "moment";
import "moment/locale/zh-cn";
import "./utils/directives.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
moment.locale("zh-cn");
Vue.use(Antd);
Vue.use(iView);
Vue.use(ElementUI);
Vue.config.lang = "zh-CN";
Vue.config.productionTip = false;

import { appIp, weifei } from "config";

new Vue({
  el: "#app",
  router: router,
  store: store,
  render: (h) => h(App),
  data: {
    currentPageName: "",
  },
  methods: {
    getUserMenu() {
      let computedRouter = [];
      let role_id = Cookies.get("roleId");
      xhr(
        {
          url: `${appIp}/users/router?role_id=${role_id}`,
          method: "get",
          sync: true,
          headers: {
            token: Cookies.get("token1"),
          },
        },
        (err, res, body) => {
          let info = JSON.parse(body);
          let _this = this;
          if (Object.is(info.code, 200)) {
            let template_obj = {};
            let return_router = [];
            // 计算默认首页
            if (info.data.user_route.length != 0) {
              let first_label = info.data.user_route[0];
              let first_array = first_label.split("-");
              let fId = parseInt(first_array[0]) - 1;
              let f_router = menuRoutes[fId];
              let first_children = f_router.children.filter((item) => {
                return item.routeId == first_label;
              })[0];
              first_children.path = "home_index";
              first_children.home_index = "home_index";
              otherRouter.children.unshift(first_children);
              _this.otherRouter = otherRouter;
              /*  console.log(otherRouter);
               debugger; */
            }
            info.data.user_route.forEach((item, key) => {
              let templateArray = item.split("-");
              let fId = parseInt(templateArray[0]) - 1;
              let f_router = menuRoutes[fId];
              // 分离出children数据
              if (f_router.hasOwnProperty("children")) {
                // 存储原来的children内容
                if (!template_obj.hasOwnProperty(fId)) {
                  template_obj[fId] = [];
                }
                let f_children = f_router.children.filter((filter_item) => {
                  return filter_item.routeId == item;
                })[0];
                template_obj[fId].push(f_children);
              }
            });
            // 数据格式处理
            for (let key in template_obj) {
              let returnArray = {};
              let current_f_router = menuRoutes.filter((item) => {
                return item.fId == parseInt(key) + 1;
              });
              returnArray = current_f_router[0];
              if (returnArray) {
                returnArray.children = [];
                template_obj[key].forEach((item) => {
                  returnArray.children.push(item);
                });
              }
              return_router.push(returnArray);
            }
            // router.addRoutes(return_router);
            computedRouter = return_router;
            // console.log("bdfd");
            // console.log(computedRouter);
            if (computedRouter) {
              _this.$router.addRoutes(computedRouter);
              this.$router.options.routes =
                this.$router.options.routes.concat(computedRouter);
              _this.computedRouter = computedRouter;
              _this.$store.commit("setAppRouter", computedRouter);
              new Promise((resolve) => {
                router.onReady((data) => {
                  resolve(data);
                });
              });
            }
          }
        }
      );
    },
  },
  mounted() {
    this.currentPageName = this.$route.name;
    // 显示打开的页面的列表
    this.$store.commit("setOpenedList");
    this.$store.commit("initCachepage");
    // 权限菜单过滤相关
    this.$store.commit("updateMenulist");

    if (
      Cookies.get("roleId") &&
      Cookies.get("roleId") != "undefined" &&
      Cookies.get("token") &&
      Cookies.get("token") != "undefined"
    ) {
      // this.getUserMenu();
      this.$router.beforeEach((to, from, next) => {
        iView.LoadingBar.start();
        Util.title(to.meta.title);
        if (Cookies.get("locking") === "1" && to.name !== "locking") {
          // 判断当前是否是锁定状态
          next({
            replace: true,
            name: "locking",
          });
        } else if (Cookies.get("locking") === "0" && to.name === "locking") {
          next(false);
        } else {
          if (!Cookies.get("user") && to.name !== "login") {
            // 判断是否已经登录且前往的页面不是登录页
            next({
              name: "login",
            });
          } else if (Cookies.get("user") && to.name === "login") {
            // 判断是否已经登录且前往的是登录页
            Util.title();
            next({
              name: "home_index",
            });
          } else {
            const curRouterObj = Util.getRouterObjByName(
              [otherRouter, ...appRouter],
              to.name
            );
            if (curRouterObj && curRouterObj.access !== undefined) {
              // 需要判断权限的路由
              if (curRouterObj.access === parseInt(Cookies.get("access"))) {
                Util.toDefaultPage(
                  [otherRouter, ...appRouter],
                  to.name,
                  router,
                  next
                ); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
              } else {
                next({
                  replace: true,
                  name: "error-403",
                });
              }
            } else {
              // 没有配置权限的路由, 直接通过
              Util.toDefaultPage([...routers], to.name, router, next);
            }
          }
        }
      });

      this.$router.afterEach((to) => {
        Util.openNewPage(router.app, to.name, to.params, to.query);
        iView.LoadingBar.finish();
        window.scrollTo(0, 0);
      });
    } else {
      self.location.href = "login.html";
    }
  },
  created() {
    let tagsList = [];
    window._this = this;
    appRouter.map((item) => {
      if (item.children.length <= 1) {
        tagsList.push(item.children[0]);
      } else {
        tagsList.push(...item.children);
      }
    });
    this.$store.commit("setTagsList", tagsList);
  },
});
